import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
// import PublicIcon from "@mui/icons-material/Public";
import {
  AIRPORTS,
  // REGIONAL_AIRSPACE
} from "../constants";
import "./HubSelector.css";

function HubSelector({ isOpen, onClose, onSelectHub }) {
  const { t } = useTranslation();

  const handleSelect = useCallback(
    (hubCode) => {
      onSelectHub(hubCode);
      onClose();
    },
    [onSelectHub, onClose],
  );

  if (!isOpen) return null;

  return (
    <div className="hub-selector-overlay" onClick={onClose}>
      <div className="hub-selector-modal" onClick={(e) => e.stopPropagation()}>
        <button
          className="hub-selector-close"
          onClick={onClose}
          aria-label={t("bookFlight.close")}
        >
          <CloseIcon />
        </button>
        <h2 className="hub-selector-title">{t("hubSelector.title")}</h2>
        <p className="hub-selector-subtitle">{t("hubSelector.subtitle")}</p>

        {/* <button
          className="hub-selector-card hub-selector-regional"
          onClick={() => handleSelect(REGIONAL_AIRSPACE.hubCode)}
        >
          <div className="hub-selector-card-icon hub-selector-card-icon-regional">
            <PublicIcon style={{ fontSize: 28 }} />
          </div>
          <div className="hub-selector-card-text">
            <strong>{t("hubSelector.allAirports")}</strong>
            <span>{t("hubSelector.allAirportsDesc")}</span>
          </div>
        </button> */}

        <div className="hub-selector-grid">
          {[...AIRPORTS]
            .sort((a, b) => a.country.localeCompare(b.country))
            .map((airport) => (
              <button
                key={airport.iataCode}
                className="hub-selector-card"
                onClick={() => handleSelect(airport.hubCode)}
              >
                <img
                  className="hub-selector-flag"
                  src={`/images/flags/${airport.flagCode}.png`}
                  alt={airport.country}
                  width="40"
                  height="30"
                />
                <strong className="hub-selector-country">
                  {t(`countries.${airport.country}`, {
                    defaultValue: airport.country,
                  }).toUpperCase()}
                </strong>
                <span className="hub-selector-city">
                  {`${airport.city.split(",")[0]}, ${t(`countries.${airport.country}`, { defaultValue: airport.country })}`}
                </span>
              </button>
            ))}
        </div>
      </div>
    </div>
  );
}

export default HubSelector;
